__webpack_require__.p = "/simonSaysGame/";